import { React, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "../navigation/Auth/RequireAuth";
import { Login } from "../pages/scenes/auth/Login";
import { ForgetPassword } from "../pages/scenes/auth/forget_password";
import { ResendCode } from "../pages/scenes/auth/Resend_code";
import { ResetPassword } from "../pages/scenes/auth/reset_password";
import Dashboard from "../pages/scenes/dashboard";
import Staff from "../pages/scenes/staff";
import ViewStaff from "../pages/scenes/staff/ViewStaff";
import StaffRequest from "../pages/scenes/staffRequest";
import StaffDeleted from "../pages/scenes/staffDeleted";
import Order from "../pages/scenes/order";
import Account from "../pages/scenes/account";
import OrderPaid from "../pages/scenes/order/orderpaid";
import OrderUnPaid from "../pages/scenes/order/orderunpaid";
import Fund from "../pages/scenes/fund";
import FundValue from "../pages/scenes/fund/FundValue";
import BillsFund from "../pages/scenes/fund/billsFund";
import UnitsFund from "../pages/scenes/fund/unitsFund";
import ServiceCenter from "../pages/scenes/serviceCenter";
import Help from "../pages/scenes/Help";
import Contact from "../pages/scenes/contact";
import TransferReports from "../pages/scenes/Transferreports";
import AmountReports from "../pages/scenes/AmountReports";
import FundReports from "../pages/scenes/FundReports";
import Announcements from "../pages/scenes/announcements";
import Addann from "../pages/scenes/announcements/Addann";
import Forminput from "../pages/scenes/staff/form";
import Create from "../pages/scenes/staff/Create";
import {ResetPasswordStaff} from "../pages/scenes/staff/reset_password";

import Siteinfo from "../pages/scenes/fund";
import Adduser from "../pages/scenes/staffDeleted/adduser";
import CreateFund from "../pages/scenes/fund/Createfund";
import FillFund from "../pages/scenes/fund/fillCreatefund";
import CreateTransactions from "../pages/scenes/fund/transfarCreatefund";
import Orderfundcache from "../pages/scenes/fund/Orderfundcache";
import Update from "../pages/scenes/staff/Update";
import Lirtnapercentage from "../pages/scenes/fund/Lirtnapercentage";
import Billpercentage from "../pages/scenes/fund/billpercentage";
import CustomizedSelects from "../pages/scenes/fund/CustomizedSelects";
import UpdateImg from "../pages/scenes/staff/updateImg";
import Provider_syrialtel from "../pages/scenes/provider_syriatel";
import Banks from "../pages/scenes/Banks";
import PaymentMethod from "../pages/scenes/PaymentMethod";
import CreatePaymentMethod from "../pages/scenes/PaymentMethod/Create";
import CreateBank from "../pages/scenes/Banks/Create";
import Createprovider from "../pages/scenes/provider_syriatel/Create";
import ProviderSetting from "../pages/scenes/provider_MTN/ProviderSetting";
import {
  DASHBOARD,
  MARSHALLS,
  SITEINFO,
  FORGETPASSWORD,
  RESETPASSWORD,
  RESENDCODE,
} from "../navigation/CONSTANTS";
import { AuthProvider } from "../navigation/Auth/auth";
import ViewOrder from "./../pages/scenes/order/viewOrder";
import AddPrivacyPolicy from "../pages/Page1/Privacypolicy/addPrivacyPolicy";
import ConvertUnite from "../pages/scenes/fund/ConvertUnite";
import PayBillMTNSYRATEL from "../pages/scenes/fund/PayBillMTNSYRATEL";
import TransforFundCacheMobile from "../pages/scenes/fund/TransforFundCacheMobile";
import Viewprovider from "../pages/scenes/provider_syriatel/View";
import Provider_MTN from "../pages/scenes/provider_MTN";
import CreateproviderMTN from "../pages/scenes/provider_MTN/Create";
import ViewproviderMTN from "../pages/scenes/provider_MTN/View";
import AllTranscation from "../pages/scenes/transcation/getAllLiretnaTransfer";
import OrderFrom from "../pages/scenes/orderNotadmin/orderFrom";
import OrderTo from "../pages/scenes/orderNotadmin/orderTo";
import AllLiretnaTransferTo from "../pages/scenes/transcationFromTo/getAllLiretnaTransferTo";
import AllLiretnaTransferFrom from "../pages/scenes/transcationFromTo/getAllLiretnaTransferFrom";
import Services from "../pages/scenes/service";
import EPayment from "../pages/scenes/EPayment";
import AddEPayment from "../pages/scenes/EPayment/Add_Epayment";
import Profile from "../pages/scenes/Profile/Update";
import { ResetPasswordAccount } from "../pages/scenes/auth/reset_password_Account";
import CompanyBalance from "../pages/scenes/company-balance";
import ShippingOperations from "../pages/scenes/company-balance/ShippingOperations";
import DashboardNoAdmin from "../pages/scenes/dashboard/indexnoAdmin";
import { PrivcePoliceAccept } from "../pages/scenes/auth/privcepoliceAccept";
import AddNotifcation from "../pages/scenes/Notifcations/AddNotifcation";
import Notifcation from "../pages/scenes/Notifcations";
import CitiesCrud from "../pages/scenes/CitiesAndZoneCrud/indexCities";
import ViewCities from "../pages/scenes/CitiesAndZoneCrud/ViewCities";
import CreateCities from "../pages/scenes/CitiesAndZoneCrud/CreateCities";
import ZonesCrud from "../pages/scenes/CitiesAndZoneCrud/indexZones";
import ViewZones from "../pages/scenes/CitiesAndZoneCrud/ViewZones";
import CreateZone from "../pages/scenes/CitiesAndZoneCrud/CreateZone";
import Ledger from "../pages/scenes/Ledger";
import Calculate_profit from "../pages/scenes/Ledger/Calculation_profit";
import { getConfigMode } from "../services/ConfigMode";
import MaintenancePage from "../pages/scenes/global/Maintenance";
import Config_Epayment from "../pages/scenes/EPayment/Config_Epayment";
const RouterConfig = () => {
  const [Config, setConfig] = useState("");
  useEffect(() => {
   
    getConfigMode()
      .then((res) => {
        setConfig(res.data.maintenance_mode);
    
      })
      .catch((err) => {
        setConfig([]);

      });

  

    return () => {};
  }, []);
  const staff_type = localStorage.getItem('staff_type');

  return (
    <>
      <AuthProvider>
        <Routes>
          {localStorage.getItem("is loggedIn")
            ? console.log("yes")
            : console.log("no")}

          <Route
            path="/"
            element={
              localStorage.getItem("is loggedIn") ? (
                // Config == 1 &&  staff_type !== 'Admin' ?(
                //   <Route exact path="/maintenance" element={<PrivcePoliceAccept />} />

                // ):(
                <Navigate to="/dashboard" />
               
                // )
              ) : (
                <Login />
              )
            }
          />

       <Route exact path="/maintenance" element={<MaintenancePage />} />

        <Route exact path="/privce-police" element={<PrivcePoliceAccept />} />
          <Route exact path="/orderunpaid" element={<OrderUnPaid />} />
          <Route exact path="/orderpaid" element={<OrderPaid />} />
          <Route exact path="/transctionReport" element={<TransferReports />} />
          <Route exact path="/amountReport" element={<AmountReports />} />
          <Route exact path="/fundReport" element={<FundReports />} />
          <Route
            exact
            path="/update_personal_image/:id"
            element={<UpdateImg />}
          />
          <Route
            exact
            path={DASHBOARD}
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
      
          <Route
            exact
            path="/privacy-policy"
            element={
              <RequireAuth>
                <AddPrivacyPolicy />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/staff"
            element={
              <RequireAuth>
                <Staff />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/staffReqest"
            element={
              <RequireAuth>
                <StaffRequest />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/staffDeleted"
            element={
              <RequireAuth>
                <StaffDeleted />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/getfund"
            element={
              <RequireAuth>
                <Fund />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/getUnitsfund"
            element={
              <RequireAuth>
                <UnitsFund />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/getBillsfund"
            element={
              <RequireAuth>
                <BillsFund />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/viewstaff/:id"
            element={
              <RequireAuth>
                <ViewStaff />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/viewValue/:id"
            element={
              <RequireAuth>
                <FundValue />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/vieworder/:id"
            element={
              <RequireAuth>
                <ViewOrder />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/order"
            element={
              <RequireAuth>
                <Order />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/accounts"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/contact"
            element={
              <RequireAuth>
                <Contact />
              </RequireAuth>
            }
          />

          <Route
            exact
            path="/servicecenter"
            element={
              <RequireAuth>
                <ServiceCenter />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/help"
            element={
              <RequireAuth>
                <Help />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/addUser"
            element={
              <RequireAuth>
                <Adduser />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/announcements"
            element={
              <RequireAuth>
                <Announcements />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/add"
            element={
              <RequireAuth>
                <Addann />
              </RequireAuth>
            }
          />
          <Route
            exact
            path={SITEINFO}
            element={
              <RequireAuth>
                <Siteinfo />
              </RequireAuth>
            }
          />
          <Route exact path={FORGETPASSWORD} element={<ForgetPassword />} />
          <Route exact path={RESETPASSWORD} element={<ResetPassword />} />
          <Route exact path={RESETPASSWORD} element={<ResetPassword />} />
          <Route exact path='reset-password-staff/:id' element={<ResetPasswordStaff />} />
          <Route exact path='reset-password-account' element={<ResetPasswordAccount />} />
          <Route exact path={RESENDCODE} element={<ResendCode />} />
          <Route
            exact
            path="/update-staff/:id/:cityid/:zoneid"
            element={<Update />}
          />
          <Route exact path="/update-request/:id" element={<Update />} />

          <Route
            exact
            path="/create-Fund"
            element={
              <RequireAuth>
                <CreateFund />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/create-staff"
            element={
              <RequireAuth>
                <Create />
              </RequireAuth>
            }
          />

          <Route
            exact
            path="/select"
            element={
              <RequireAuth>
                <CustomizedSelects />
              </RequireAuth>
            }
          />

          <Route
            exact
            path="/fill-fund"
            element={
              <RequireAuth>
                <FillFund />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/transfar-fund-cache"
            element={
              <RequireAuth>
                <CreateTransactions />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/order-fund-cache"
            element={
              <RequireAuth>
                <Orderfundcache />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/convert-unite"
            element={
              <RequireAuth>
                <ConvertUnite />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/pay-bill"
            element={
              <RequireAuth>
                <PayBillMTNSYRATEL />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/balance-transfer-cache-mobile"
            element={
              <RequireAuth>
                <TransforFundCacheMobile />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/forminput"
            element={
              <RequireAuth>
                <Forminput />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/forminput"
            element={
              <RequireAuth>
                <Forminput />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/lirtna-percentage/:id"
            element={
              <RequireAuth>
                <Lirtnapercentage />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/bill-percentage/:id"
            element={
              <RequireAuth>
                <Billpercentage />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/providers"
            element={
              <RequireAuth>
                <Provider_syrialtel />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/create-provider"
            element={
              <RequireAuth>
                <Createprovider />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/provider/:id"
            element={
              <RequireAuth>
                <Viewprovider />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/providers-mtn"
            element={
              <RequireAuth>
                <Provider_MTN/>
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/create-provider-mtn"
            element={
              <RequireAuth>
                <CreateproviderMTN />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/provider-mtn-setting"
            element={
              <RequireAuth>
                <ProviderSetting />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/provider-mtn/:id"
            element={
              <RequireAuth>
                <ViewproviderMTN />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/Banks"
            element={
              <RequireAuth>
                <Banks />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/create-bank"
            element={
              <RequireAuth>
                <CreateBank />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/payment-method"
            element={
              <RequireAuth>
                <PaymentMethod />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/services"
            element={
              <RequireAuth>
                <Services />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/create-payment-method"
            element={
              <RequireAuth>
                <CreatePaymentMethod />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/transcation"
            element={
              <RequireAuth>
                <AllTranscation />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/transcation-from"
            element={
              <RequireAuth>
                <AllLiretnaTransferFrom />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/transcation-to"
            element={
              <RequireAuth>
                <AllLiretnaTransferTo />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/order-from"
            element={
              <RequireAuth>
                <OrderFrom />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/order-to"
            element={
              <RequireAuth>
                <OrderTo />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/e-payment"
            element={
              <RequireAuth>
                <EPayment />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/create-epayment"
            element={
              <RequireAuth>
                <AddEPayment />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/config-epayment"
            element={
              <RequireAuth>
                <Config_Epayment />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/company-balance"
            element={
              <RequireAuth>
                <CompanyBalance />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/shipping-operations"
            element={
              <RequireAuth>
                <ShippingOperations />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/add-Notifcation"
            element={
              <RequireAuth>
                <AddNotifcation />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/notifcation"
            element={
              <RequireAuth>
                <Notifcation />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/Citeis"
            element={
              <RequireAuth>
                <CitiesCrud />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/city/:id"
            element={
              <RequireAuth>
                <ViewCities />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/create-city"
            element={
              <RequireAuth>
                <CreateCities />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/city-zone/:id"
            element={
              <RequireAuth>
                <ZonesCrud />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/zone/:id"
            element={
              <RequireAuth>
                <ViewZones />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/create-zone"
            element={
              <RequireAuth>
                <CreateZone />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/ledger"
            element={
              <RequireAuth>
                <Ledger />
              </RequireAuth>
            }
          />
            <Route
            exact
            path="/calculate_profit"
            element={
              <RequireAuth>
                <Calculate_profit />
              </RequireAuth>
            }
          />
        </Routes>
      </AuthProvider>
    </>
  );
};

export default RouterConfig;
